import React from "react";
import ProductCard from './productCard/ProductCard'
import '../css/search.css'
import '../css/index.css'

export default function renderSearchResults(props) {
    if (props.results && Array.isArray(props.results) && props.results.length > 0) {
        return (
            <div className="results-container">
                {props.results.map(result => {
                    return (
                        <ProductCard key={result.ProductSku || Math.random()} result={result} />
                    )
                })}
            </div>
        )
    } else {
        return null
    }
}